import {
   CurrentDoctorSimpleQuery,
   DoctorSimple,
   DoctorSimpleFromCurrentHealthcareProviderQuery,
} from '@dreryk/egabinet-personnel-frontend-api';

import {
   CqrsQueryPerformResult,
   performCqrsQuerySearch,
   useCqrsFind,
   UseCqrsQueryOptions,
   UseCqrsQueryResult,
   useCqrsSearch,
} from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';

export const useHealthcareProviderDoctorsQuery = (
   options?: UseCqrsQueryOptions<DoctorSimple[]>
): UseCqrsQueryResult<DoctorSimple[]> => {
   return useCqrsSearch<DoctorSimple>(
      () => new DoctorSimpleFromCurrentHealthcareProviderQuery(),
      paginations.all(),
      options
   );
};

export const healthcareProviderDoctorsSearchCreator = (options?: UseCqrsQueryOptions<DoctorSimple[]>) => {
   return async (): CqrsQueryPerformResult<DoctorSimple[]> =>
      performCqrsQuerySearch<DoctorSimple>(
         () => new DoctorSimpleFromCurrentHealthcareProviderQuery(),
         paginations.all(),
         options
      );
};

export const useCurrentDoctorSimpleQuery = (
   options?: UseCqrsQueryOptions<DoctorSimple | null>
): UseCqrsQueryResult<DoctorSimple | null> => {
   return useCqrsFind(() => new CurrentDoctorSimpleQuery(), options);
};
